export class Views {
	public static readonly SPIN_BUTTON_VIEW: string = 'SpinButtonView';
	public static readonly SPIN_BUTTON_VIEW_MOBILE: string = 'SpinButtonViewMobile';

	public static readonly AVALANCHE_REELS_VIEW: string = 'AvalancheReelsView';
	public static readonly AVALANCHE_REELS_VIEW_MOBILE: string = 'AvalancheReelsViewMobile';

	public static readonly REELS_VIEW: string = 'ReelsView';
	public static readonly REELS_VIEW_MOBILE: string = 'ReelsViewMobile';

	public static readonly INDIVIDUAL_SYMBOLS_REELS_VIEW: string = 'IndividualSymbolReelsView';
	public static readonly INDIVIDUAL_SYMBOLS_REELS_VIEW_MOBILE: string = 'IndividualSymbolReelsViewMobile';

	public static readonly KEYPAD_INFO_ELEMENTS_VIEW: string = 'KeypadInfoElementsView';
	public static readonly KEYPAD_INFO_ELEMENTS_VIEW_MOBILE: string = 'KeypadInfoElementsViewMobile';

	public static readonly KEYPAD_CONTROLS_VIEW: string = 'KeypadControlsView';
	public static readonly KEYPAD_CONTROLS_VIEW_MOBILE: string = 'KeypadControlsViewMobile';

	public static readonly SWIPE_INTERACTION_VIEW: string = 'SwipeInteractionView';
	public static readonly SWIPE_INTERACTION_VIEW_MOBILE: string = 'SwipeInteractionViewMobile';

	public static readonly AUTOPLAY_VIEW: string = 'AutoplayView';
	public static readonly AUTOPLAY_VIEW_MOBILE: string = 'AutoplayViewMobile';

	public static readonly BET_LEVEL_MENU_VIEW: string = 'BetlevelMenuView';
	public static readonly BET_LEVEL_MENU_VIEW_MOBILE: string = 'BetlevelMenuViewMobile';

	public static readonly BET_VIEW: string = 'BetButtonView';
	public static readonly BET_VIEW_MOBILE: string = 'BetButtonViewMobile';

	public static readonly MENUBUTTON_VIEW: string = 'MenuButtonView';
	public static readonly MENUBUTTON_VIEW_MOBILE: string = 'MenuButtonViewMobile';

	public static readonly SOUND_POPUP_VIEW_MOBILE: string = 'SoundPopupViewMobile';

	public static readonly MAIN_MENU_VIEW: string = 'MainMenuView';
	public static readonly MAIN_MENU_VIEW_MOBILE: string = 'MainMenuViewMobile';

	public static readonly MENU_BAR_VIEW: string = 'MenuBarView';
	public static readonly MENU_BAR_VIEW_MOBILE: string = 'MenuBarViewMobile';

	public static readonly SETTINGS_VIEW: string = 'SettingsView';
	public static readonly SETTINGS_VIEW_MOBILE: string = 'SettingsViewMobile';

	public static readonly GAME_RULES_VIEW: string = 'GameRulesView';
	public static readonly GAME_RULES_VIEW_MOBILE: string = 'GameRulesViewMobile';

	public static readonly STARTSCREEN_VIEW: string = 'StartscreenView';
	public static readonly STARTSCREEN_VIEW_MOBILE: string = 'StartscreenViewMobile';

	public static readonly KEYPAD_VIEW: string = 'KeypadView';
	public static readonly KEYPAD_VIEW_MOBILE: string = 'KeypadViewMobile';

	public static readonly WIN_PRESENTATION_VIEW: string = 'WinPresentationView';
	public static readonly WIN_PRESENTATION_VIEW_MOBILE: string = 'WinPresentationViewMobile';

	public static readonly BIG_WIN_VIEW: string = 'BigWinView';
	public static readonly BIG_WIN_VIEW_MOBILE: string = 'BigWinViewMobile';

	public static readonly BONUS_VIEW: string = 'BonusView';
	public static readonly BONUS_VIEW_MOBILE: string = 'BonusViewMobile';

	public static readonly FREE_SPINS_INTRO_VIEW: string = 'FreeSpinsIntroView';
	public static readonly FREE_SPINS_INTRO_VIEW_MOBILE: string = 'FreeSpinsIntroViewMobile';

	public static readonly FREE_SPINS_OUTRO_VIEW: string = 'FreeSpinsOutroView';
	public static readonly FREE_SPINS_OUTRO_VIEW_MOBILE: string = 'FreeSpinsOutroViewMobile';

	public static readonly FREE_SPINS_RETRIGGER_VIEW: string = 'FreeSpinsRetriggerView';
	public static readonly FREE_SPINS_RETRIGGER_VIEW_MOBILE: string = 'FreeSpinsRetriggerViewMobile';

	public static readonly BACKGROUND_VIEW: string = 'BackgroundView';
	public static readonly BACKGROUND_VIEW_MOBILE: string = 'BackgroundViewMobileMobile';

	public static readonly AUTOPLAY_MENU_VIEW: string = 'AutoplayMenuView';
	public static readonly AUTOPLAY_MENU_VIEW_MOBILE: string = 'AutoplayMenuViewMobile';

	public static readonly ANTICIPATOR_VIEW: string = 'AnticipatorView';
	public static readonly ANTICIPATOR_VIEW_MOBILE: string = 'AnticipatorViewMobile';

	public static readonly FOREGROUND_VIEW: string = 'ForegroundView';
	public static readonly FOREGROUND_VIEW_MOBILE: string = 'ForegroundViewMobile';

	public static readonly PARTICLE_VIEW: string = 'ParticleView';
	public static readonly PARTICLE_VIEW_MOBILE: string = 'ParticleViewMobile';

	public static readonly CHEATS_VIEW: string = 'CheatsView';
	public static readonly CHEATS_VIEW_MOBILE: string = 'CheatsViewMobile';

	public static readonly STOP_AUTOPLAY_BUTTON_VIEW: string = 'StopAutoplayButtonView';
	public static readonly STOP_AUTOPLAY_BUTTON_VIEW_MOBILE: string = 'StopAutoplayButtonViewMobile';

	public static readonly ORIENTATION_NOTIFICATION_VIEW: string = 'OrientationNotificationView';

	public static readonly INFO_VIEW: string = 'InfoView';
	public static readonly INFO_VIEW_MOBILE: string = 'InfoViewMobile';

	public static readonly LOGOTYPE_VIEW: string = 'LogotypeView';
	public static readonly LOGOTYPE_VIEW_MOBILE: string = 'LogotypeViewMobile';

	public static readonly INFO_POPUP_VIEW: string = 'InfoPopupView';
	public static readonly INFO_POPUP_VIEW_MOBILE: string = 'InfoPopupViewMobile';

	public static readonly MICROGAMING_FREEROUNDS_VIEW: string = 'FreeRoundsScreenView';
	public static readonly MICROGAMING_FREEROUNDS_VIEW_MOBILE: string = 'FreeRoundsScreenViewMobile';

	public static readonly MICROGAMING_INFREEROUNDS_VIEW: string = 'InFreeRoundsScreenView';
	public static readonly MICROGAMING_INFREEROUNDS_VIEW_MOBILE: string = 'InFreeRoundsScreenViewMobile';

	public static readonly STATISTICS_WINDOW_VIEW: string = 'StatisticsWindowView';
	public static readonly STATISTICS_WINDOW_VIEW_MOBILE: string = 'StatisticsWindowViewMobile';

	public static readonly FREE_SPINS_INFO_VIEW: string = 'FreeSpinsInfoView';
	public static readonly FREE_SPINS_INFO_VIEW_MOBILE: string = 'FreeSpinsInfoViewMobile';

	public static readonly FREE_SPINS_VIEW: string = 'FreeSpinsView';
	public static readonly FREE_SPINS_VIEW_MOBILE: string = 'FreeSpinsViewMobile';

	public static readonly RELAX_FREEROUNDS_VIEW: string = 'RelaxFreeRoundsView';
	public static readonly RELAX_FREEROUNDS_INGAME_VIEW: string = 'RelaxInFreeRoundsView';

	public static readonly REEL_EFFECTS_VIEW: string = 'ReelEffectsView';

	public static readonly GAME_HISTORY_VIEW: string = 'GAME_HISTORY_VIEW';

	public static readonly RELAX_SCREEN_BLOCKER: string = 'RelaxScreenBlocker';
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/common/view/Views.ts